

export default class {
    constructor($el, windowPal) {
        this.$ = $el;
        this.windowPal = windowPal;
        this.$trigger = $($el.data('hide-to-reveal-mobile')).find('[data-reveal-trigger]');
        this.isOpen = false;
        this.buttonTextOpen = this.$trigger.text();
        this.buttonTextNotOpen = this.$trigger.data('reveal-trigger');
        console.log('trigger', this.$trigger[0]);
        this.$trigger.click(()=>{
            this.click();
        });
    }
    click() {
        if (this.isOpen) {
            this.close();
        } else {
            this.open();
        }
    }
    open() {
        this.isOpen = true;
        this.$.addClass('-display');
        this.$trigger.text(this.buttonTextNotOpen);
        setTimeout(()=>{
            this.$.addClass('-opaque');
        }, 10);
        // console.log('open');
    }
    close() {
        this.isOpen = false;
        this.$.removeClass('-opaque');
        this.$trigger.text(this.buttonTextOpen);
        setTimeout(()=>{
            this.$.removeClass('-display');
        }, 10);
        // console.log('close');
    }
}







// WEBPACK FOOTER //
// ./scripts/lib/HideToRevealMobile.js